(function () {
    "use strict";

    angular.module("app").factory("arrayUtilities", ArrayUtilitiesFactory);

    ArrayUtilitiesFactory.$inject = [];
    function ArrayUtilitiesFactory() {
        return {
            RemoveItem: removeItem,
        };

        function removeItem(array, item) {
            if (!Array.isArray(array)) {
                console.error("Provided parameter is not an array");
                return;
            }

            const index = array.indexOf(item);
            if (index > -1)
                array.splice(index, 1);
        }
    }
})();
